<template>
  <div class="bgmusic">
    <div class="bgmusic-top">
      <span>
        <img src="../../assets/img/home-icon.png" alt="" class="home-icon-img">
        <router-link :to="{ name: 'home' }">首页</router-link>
      </span>&nbsp;/&nbsp;
      <span>
        素材管理
      </span>&nbsp;/&nbsp;
      <span>
        背景音乐
      </span>
      <el-button icon="el-icon-back" class="retrunbtn" type="text" @click="urlback" v-if="referer">返回</el-button>
    </div>
    <div class="bgmusic-content">
      <div class="bgmusic-content-search">
        <el-upload class="upload-bgmusic" action="/api/file/upload" :headers="headers" :show-file-list="false"
          :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" multiple accept=".mp3">
          <el-button class="upload-bgmusic" :loading="uploading">
            <img src="../../assets/img/upload-icon.png" alt="">
            上传
          </el-button>
        </el-upload>
        <audio ref="audio" controls id="audio" style="position: fixed;bottom: 10px;left :10px;" hidden></audio>
        <div>
          <span class="bgmusic-search-title">名称：</span>
          <el-input v-model="bgmusicValue" placeholder="请输入背景音乐名称" class="bgmusic-name-sear"></el-input>
          <el-button @click="searchHandle" icon="el-icon-search" class="bgmusic-search-btn">搜索</el-button>
        </div>
      </div>
      <!--  -->
      <div class="bgmusic-center material-list">
        <el-table :data="bgMusicData" style="width: 100%"
          :header-cell-style="{ backgroundColor: '#f1f1f1', color: '#000', fontSize: '14px', fontWeight: '400' }" stripe
          @selection-change='selRow' ref="multipleTable" v-loading="loading">
          <el-table-column type="selection" width="50" :selectable="selectable">
          </el-table-column>
          <el-table-column prop="file_name" label="名称" width="410px">
            <template slot-scope="scope">
              <div class="bgmusic-img-box">
                <div class="bgmusic-img">
                  <img src="../../assets/img/bgmusic-icon.png" alt="">
                </div>
                <span>{{ scope.row.file_name }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="file_id" label="来源">
            <template slot-scope="scope">
              {{ scope.row.uid > 0 ? "自定义" : "系统推荐" }}
            </template>
          </el-table-column>
          <el-table-column prop="url" label="试听">
            <template slot-scope="scope">
              <el-button @click="play(scope.row)" type="text" class="el-icon-video-play">
                试听
              </el-button>
            </template>
          </el-table-column>

        </el-table>
      </div>
      <!--  -->
      <div class="bgmusic-bottom material-page">
        <div class="bgmusic-bottom-left">
          <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="selAll()">全选</el-checkbox>
          <el-button class="bgmusic-del-btn" @click="delHandel">删除</el-button>
        </div>
        <el-pagination @current-change="handleCurrentChange" :current-page="current" :page-size="pageSize"
          layout="total, prev, pager, next" :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import Audio from '../../views/admin/Audio.vue';
export default {
  components: { Audio },
  name: 'bgMusicPage',
  data() {
    return {
      isIndeterminate: false,//对el-checkbox控制不完整的全选状态
      checkAll: false,//对el-checkbox控制全选状态
      // 名字
      bgmusicValue: '',
      // 表格数据
      bgMusicData: [
      ],
      //全选
      checked: '',
      selects: [],
      headers: {},
      uploading: false,
      referer: '',
      loading: false,
      // 分页
      current: 1,
      pageSize: 12,
      total: 0,
    }
  },
  created() {
    var query = this.$route.query;
    this.referer = query.referer;
    this.query();
    this.headers = { Authorization: 'Bearer ' + localStorage.getItem('ai-token') };
  },
  beforeRouteLeave(to, from, next) {
    this.$refs.audio.pause();
    next();
  },
  methods: {
    // 分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.current = val;
      this.query();
    },
    // 上传背景音乐
    handleAvatarSuccess(res, file) {
      this.$message.closeAll();
      if (res.code == 200) {
        this.$message.success(file.name + "上传完成");
        this.query();
      } else {
        this.$message.success(file.name + res.msg);
      }
      this.uploading = false;
    },
    // 搜索
    searchHandle() {
      this.current = 1;
      this.query();
    },
    // 表格中删除
    operationHandle(row) {
      console.log(row)
    },
    // 删除
    delHandel() {
      this.$post('/music/del', { ids: this.selects }).then(res => {
        if (res.code == 200) {
          this.$message.success('删除完成');
          this.query();
        }
      })
    },
    selAll() {
      if (this.$refs.multipleTable.selection.length < this.bgMusicData.length) {
        this.checkAll = true;
      } else {
        this.checkAll = false;
      }
      this.$refs.multipleTable.toggleAllSelection();
    },
    //表格内checkbox触发的全选按钮状态变化
    selRow(val) {
      if (val.length < this.bgMusicData.length && val.length > 0) {
        this.isIndeterminate = true;
      } else if (val.length == this.bgMusicData.length) {
        this.isIndeterminate = false;
        this.checkAll = true;
      } else if (val.length == 0) {
        this.isIndeterminate = false;
        this.checkAll = false;
      }
      this.selects = [];
      for (let i in val) {
        this.selects.push(val[i].file_id);
      }
    },
    query() {
      this.loading = true;
      this.$get('/music/list', {
        page: this.current,
        size: this.pageSize,
        name: this.bgmusicValue,
      }).then(res => {
        this.bgMusicData = res.data.data;
        this.total = res.data.total;
        this.loading = false;
      })
    },
    beforeAvatarUpload() {
      this.uploading = true;
    },
    play(row) {
      this.$refs.audio.src = row.url;
      this.$refs.audio.play();
    },
    selectable(row, index) {
      if (row.uid == 0) return false;
      return true;
    },
    urlback() {
      this.$router.go(-1);
    },

  },

}

</script>

<style scoped>
.bgmusic-top {
  width: 100%;
  height: 50px;
  background-color: #fff;
  border-radius: 3px;
  margin-bottom: 10px;
  box-sizing: border-box;
  padding: 16px 20px;
}

.bgmusic-top {
  color: #606266;
  font-size: 14px;
}

.bgmusic-top .home-icon-img {
  margin-right: 4px;
}

.bgmusic-top a {
  color: #606266;
}

.bgmusic-top a:hover {
  color: #006cff;
}

.bgmusic-content {
  background-color: #fff;
  box-sizing: border-box;
  padding: 0 20px;
  padding-bottom: 24px;
  position: relative;
}

.bgmusic-content-search {
  box-sizing: border-box;
  padding: 16px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e5e5e5;
}

.bgmusic-search-btn {
  width: 88px;
  height: 40px;
  background-color: #006cff !important;
  border-radius: 3px;
  color: #fff !important;
  margin-left: 10px;
  border: none;
  /* 新增 */
  opacity: 1;
  transition: all 0.2s ease;
}

/* 新增 */

.bgmusic-search-btn:hover {
  opacity: 0.9;
}

.bgmusic-name-sear {
  width: 278px;
  height: 40px;
}

.bgmusic-search-title {
  font-size: 14px;
  color: #333;
}

.upload-bgmusic {
  width: 150px;
  height: 40px;
  background-color: #006cff !important;
  border-radius: 3px;
  color: #fff !important;
  border: none;
  /* 新增 */

  opacity: 1;
  transition: all 0.2s ease;
}

/* 新增 */

.upload-bgmusic:hover {
  opacity: 0.9;
}

.bgmusic-img {
  width: 44px;
  height: 44px;
  background-color: #573dff;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
}

.bgmusic-img-box {
  display: flex;
  align-items: center;
  color: #333;
  font-size: 14px;
}

.bgmusic-del-btn-box>>>span {
  display: flex;
  align-items: center;
  justify-content: center;
}

.bgmusic-del-btn-box>span>img {
  margin-right: 4px;
}

.bgmusic-del-btn-bxo>span>span {
  font-size: 14px;
}

.bgmusic-center>>>.el-table__row--striped {
  background-color: #f7f8f8;
}

.bgmusic-center>>>.el-table--striped .el-table__body tr.el-table__row--striped td.el-table__cell {
  background-color: #f7f8f8;
}

.bgmusic-center>>>.el-table .el-table__body tr:hover>td {
  background-color: #e3eefd !important;
}

.bgmusic-center>>>.el-table .el-table__body tr.current-row>td {
  background-color: #e3eefd !important;
}

.bgmusic-bottom {
  width: 96%;
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.bgmusic-bottom .el-pagination {
  color: #606266;
  font-weight: 400;
}

.bgmusic-bottom .el-pagination>>>button {
  border: 1px solid #d9d9d9 !important;
  border-radius: 3px;
  padding: 0;
  min-width: 28px !important;
}

.bgmusic-bottom .el-pagination .btn-next,
.el-pagination .btn-prev {
  background: center center no-repeat #FFF;
  background-size: 16px;
  cursor: pointer;
  margin: 0;
  color: #606266;
}

.bgmusic-bottom .el-pagination .el-select .el-input {
  width: 90px;
  margin: 0 5px;
}

.bgmusic-bottom .el-pagination>>>.el-pagination__jump {
  margin-left: 10px;
  font-weight: 400;
  color: #606266;
}

.bgmusic-del-btn {
  width: 74px;
  height: 32px;
  border: 1px solid #d9d9d9;
  border-radius: 3px;
  background: rgba(255, 255, 255, 0.09);
  padding: 0;
  margin-left: 10px;
}

.bgmusic-bottom-left {
  margin-left: 14px;
}

.bgmusic-bottom-left>>>.el-checkbox__label {
  padding-left: 20px;
}

.bgmusic-content>>>.el-checkbox__input.is-checked .el-checkbox__inner,
.bgmusic-content>>>.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #006CFF;
  border-color: #006CFF;
}

.bgmusic-center {
  overflow-y: auto;
  height: calc(100vh - 250px);
}

@media screen and (max-width:1024px) {
  .bgmusic-bottom {
    flex-wrap: wrap;
  }

  .bgmusic-bottom-left {
    margin-bottom: 10px;
  }
}



@media screen and (max-width:1250px) {


  .bgmusic-bottom {
    left: 0;
    width: 100%;
    box-sizing: border-box;
    padding-right: 2%;
  }
}
</style>